/**
 * 指令仓库实体组件
 */

import { useState, useEffect } from 'react';
import { Modal, Input, Row, Col, message } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '公共指令';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [role, setRole] = useState('');
    const [scene, setScene] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setTitle('');
        setContent('');
        setRole('');
        setScene('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setTitle(props.record.title);
            setContent(props.record.content);
            setRole(props.record.role);
            setScene(props.record.scene);
        }
    }, [props.record]);

    const ok = () => {
        // 参数校验
        if (title === '') {
            messageApi.error('标题不能为空！');
            return;
        }
        if (content === '') {
            messageApi.error('内容不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'command/publics' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'title': title,
                'content': content,
                'role': role,
                'scene': scene,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={700}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>标题{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={title}
                            onChange={(e) => { setTitle(e.target.value) }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ lineHeight: CNF.lineHeight, marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>角色{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='角色，多个角色用顿号（、）隔开'
                            value={role}
                            onChange={(e) => { setRole(e.target.value) }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ lineHeight: CNF.lineHeight, marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>场景{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='场景，多个场景用顿号（、）隔开'
                            value={scene}
                            onChange={(e) => { setScene(e.target.value) }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ lineHeight: CNF.lineHeight, marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>内容{rff}</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='内容'
                            autoSize={{ minRows: 8, maxRows: 8 }}
                            value={content}
                            onChange={(e) => { setContent(e.target.value) }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity